export type GeneralComponent = (props?: any) => JSX.Element

export const getSafeComponent = (
  Component: GeneralComponent
): GeneralComponent => Component || (() => null)
